import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "react-axios";
import { getTrackGenres } from "~/api/getGenre";

const AdditionalGenresContext = createContext(null);

export function AdditionalGenresProvider({ trackId, children }) {
  const [genres, setGenres] = useState([]);

  useEffect(() => {
    if (!trackId) {
      setGenres([]);
      return;
    }
    getTrackGenres(axios, trackId)
      .then((resp) => setGenres(resp.data || []))
      .catch(() => setGenres([]));
  }, [trackId]);

  const addGenre = useCallback((newGenre) => {
    setGenres((prev) => [...prev, newGenre]);
  }, []);

  const value = trackId ? { trackId, genres, setGenres, addGenre } : null;

  return (
    <AdditionalGenresContext.Provider value={value}>
      {children}
    </AdditionalGenresContext.Provider>
  );
}

export function useAdditionalGenres() {
  return useContext(AdditionalGenresContext);
}
